import { useContext } from 'react';
import ObjectReferenceContext from '../ObjectReferenceContext';

export default function useObjectReferenceUtils() {
  return useContext(ObjectReferenceContext);
}
